import React, { Component } from 'react';
import { connect } from 'react-redux';
import Carousel from './Carousel';
import { getUserProducts } from '../../../redux/actions/product';
import ProductMiniature from '../../../commons/ProductMiniature';
import {
  USER_PRODUCT_FAILED,
  USER_PRODUCT_RETRIEVED
} from '../../../redux/actions/types';
import { withTranslation } from 'react-i18next';

class FeaturedUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.productCarousel
        ? []
        : props.user.products.map(p => ({
            ...p,
            user: {
              username: props.user.username,
              media: props.user.media,
              promotion: props.user.promotion,
              type: props.user.type
            }
          })),
      loading: false
    };
  }

  componentDidMount() {
    if (this.props.productCarousel) {
      this.props.getUserProducts(this.props.user.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.productCarousel) {
      return;
    }

    if (prevProps.status !== this.props.status) {
      if (
        this.props.status === USER_PRODUCT_RETRIEVED &&
        this.props.products.user === this.props.user.id
      ) {
        this.setState({
          products: this.props.products.products,
          loading: false
        });
      }
      if (
        this.props.status === USER_PRODUCT_FAILED &&
        this.props.products.user === this.props.user.id
      ) {
        this.setState({ loading: false });
      }
    }
  }

  render() {
    const header = this.props.productCarousel
      ? `${this.props.t('checkMoreDressers', {
          ns: 'products'
        })} ${this.props.user.username.toUpperCase()}`
      : `${this.props.user.username.toUpperCase()} PUBLICÓ ${
          this.state.products.length
        } PRODUCTOS`;
    return (
      <Carousel
        carouselHeader={header}
        carouselLink={`/vestidor/${this.props.user.username}`}
        loading={this.state.loading}
      >
        {this.state.products.map(product => (
          <ProductMiniature key={product.id} product={product} />
        ))}
      </Carousel>
    );
  }
}

const mapStateToProps = state => ({
  status: state.product.status,
  products: state.product.productsFromUser
});

const mapDispatchToProps = dispatch => ({
  getUserProducts: user => dispatch(getUserProducts(user))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FeaturedUser));
